import { DataTable, DataTableProps } from "@shopify/polaris";

type ComparisonTableProps = Omit<DataTableProps, "columnContentTypes">;

const ComparisonTable = (props: ComparisonTableProps) => {
  return <DataTable {...props} columnContentTypes={["text", "text"]} increasedTableDensity hoverable={false} />;
};

export default ComparisonTable;
